import React from 'react';
import { Card } from '@/components/ui/card';
import { CreditCard, Copy } from 'lucide-react';
import { toast } from 'sonner';

const STATUS_BADGE_COLORS = {
  pending: 'bg-amber-50 text-amber-700 border-amber-200',
  paid: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  expired: 'bg-slate-100 text-slate-500 border-slate-200',
  cancelled: 'bg-rose-50 text-rose-700 border-rose-200',
};

export const LivePaymentBadge = ({ status, testId }) => {
  const cls = STATUS_BADGE_COLORS[status] || STATUS_BADGE_COLORS.pending;
  return (
    <span
      data-testid={testId}
      className={`px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider border ${cls}`}
    >
      {status === 'paid' && '✓ '}{status}
    </span>
  );
};

export function LivePaymentLinksCard({ links }) {
  if (!links || links.length === 0) return null;

  const copy = (l) => {
    const url = l.short_url || `${window.location.origin}/pay/${l.payment_ref || l.token}`;
    navigator.clipboard.writeText(url);
    toast.success('Link copied');
  };

  const fmtNum = (n) => (n || 0).toLocaleString('en-IN');

  return (
    <Card className="p-5" data-testid="trip-live-payment-links">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-bold text-slate-900 flex items-center gap-2">
          <CreditCard className="h-4 w-4 text-teal-700" />
          Payment Links ({links.length})
        </h3>
        <div className="flex items-center gap-1.5 text-xs text-slate-400">
          <span className="w-1.5 h-1.5 bg-emerald-500 rounded-full animate-pulse" />
          Live status — auto-refreshing
        </div>
      </div>
      <div className="space-y-2">
        {links.map((l) => (
          <div key={l.linkId} className="flex items-center justify-between py-2 px-3 bg-slate-50 rounded-lg hover:bg-slate-100/60 transition">
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <span className="font-mono text-xs text-slate-700 truncate">{l.linkId}</span>
                <span className="text-[10px] text-slate-400 capitalize">· {l.gateway}</span>
              </div>
              <div className="text-xs text-slate-500 mt-0.5">
                ₹{fmtNum(l.amount)} · {new Date(l.createdAt).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' })}
              </div>
            </div>
            <div className="flex items-center gap-2">
              <LivePaymentBadge status={l.status} testId={`payment-status-${l.linkId}`} />
              <button
                onClick={() => copy(l)}
                className="text-slate-400 hover:text-slate-700"
                title="Copy link"
                data-testid={`copy-${l.linkId}`}
              >
                <Copy className="w-3.5 h-3.5" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}
